export default __webpack_public_path__ + "static/char-54-anr-5c8ea020d946e757a9441b2b7e0bfdea.gif";